import CartButton from '@components/cart/CartButton';
import Header from '@components/Header';
import useProject from '@hooks/useProject';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

interface Props {
    shopId: string;
    itemId: string;
}

function ItemHeader({ shopId, itemId }:Props) {
    const project = useProject();
    const { t } = useTranslation('item');
    return (
        <Header title={t('header.title')}
            trailing={project?.features.orderEnabled
                ? <CartButton shopId={shopId}/>
                : undefined} />
    );
}

export default ItemHeader;
